'use client';

import React, { useState } from 'react';
import { VStack } from '@skin-seoul/design-system';
import ModalContainer from '../../../components/ModalContainer';
import StarIngredientItem from '../../StarIngredientsSection/components/StarIngredientItem';
import SensitiveIngredientItem from '../../SensitiveIngredientsSection/components/SensitiveIngredientItem';
import type { StarIngredient } from '@skin-seoul/service';
interface IngredientRatingsModalProps {
  isOpen: boolean;
  onClose: () => void;
  starIngredients: StarIngredient[];
}

/**
 * currently sensitive ingredients are not given so we are not showing it
 */
const IngredientRatingsModal = ({
  isOpen,
  onClose,
  starIngredients
}: IngredientRatingsModalProps) => {
  const [expandedItem, setExpandedItem] = useState<number | null>(0);
  const handleToggle = (index: number) => {
    setExpandedItem(expandedItem === index ? null : index);
  };
  const allIngredients = [...starIngredients.map((ingredient, index) => ({
    ...ingredient,
    type: 'star' as const,
    originalIndex: index
  }))];
  return <ModalContainer isOpen={isOpen} onClose={onClose} title="Ingredients Breakdown" data-sentry-element="ModalContainer" data-sentry-component="IngredientRatingsModal" data-sentry-source-file="IngredientRatingsModal.tsx">
      {/* Ingredients List */}
      <VStack gap={2} width="100%" alignItems="stretch" data-sentry-element="VStack" data-sentry-source-file="IngredientRatingsModal.tsx">
        {allIngredients.map((ingredient, index) => {
        if (ingredient.type === 'star') {
          return <StarIngredientItem key={`star-${ingredient.originalIndex}`} name={ingredient.engName} efficacy={ingredient.efficacy} efficacyDescription={ingredient.efficacyDescription} isExpanded={expandedItem === index} onToggle={() => handleToggle(index)} isInModal />;
        } else {
          return <SensitiveIngredientItem key={`sensitive-${ingredient.originalIndex}`} name={ingredient.engName} efficacy={ingredient.efficacy} efficacyDescription={ingredient.efficacyDescription} isExpanded={expandedItem === index} onToggle={() => handleToggle(index)} />;
        }
      })}
      </VStack>
    </ModalContainer>;
};
export default IngredientRatingsModal;